export const getAllStatus: { [name: string]: { label: string, value: string, color_code: string } } = {
    "Error": {
        "label": "Error",
        "value": "Error",
        "color_code": "#F7A8A9"
    },
    "Active": {
        "label": "Active",
        "value": "Active",
        "color_code": "#8EE392"
    },
    "active": {
        "label": "Active",
        "value": "Active",
        "color_code": "#8EE392"
    },
    "Listed": {
        "label": "Listed",
        "value": "Listed",
        "color_code": "#8EE392"
    },
    "Not Listed: Offer": {
        "label": "Not Listed: Offer",
        "value": "Not Listed: Offer",
        "color_code": "#8EE392"
    },
    "Not Listed": {
        "label": "Not Listed",
        "value": "Not Listed",
        "color_code": "#FAEAAF"
    },
    "Some Variants Listed And Some Not Listed": {
        "label": "Some Variants Listed",
        "value": "Some Variants Listed And Some Not Listed",
        "color_code": "#B5F3BA"
    },
    "Some Variants Listed And Some Not Listed: Offer": {
        "label": "Some Variants Listed",
        "value": "Some Variants Listed And Some Not Listed: Offer",
        "color_code": "#B5F3BA"
    },
    "Listing in progress": {
        "label": "Listing in progress",
        "value": "Listed",
        "color_code": "#DADADA"
    },
    "Inactive": {
        "label": "Inactive",
        "value": "Listed",
        "color_code": "#DADADA"
    },
    "Incomplete": {
        "label": "Incomplete",
        "value": "Listed",
        "color_code": "#8EE392"
    },
    "Supressed": {
        "label": "Supressed",
        "value": "Supressed",
        "color_code": "#8EE392"
    },
    "Disabled": {
        "label": "Disabled",
        "value": "Disabled",
        "color_code": "#8EE392"
    },
    "Unknown": {
        "label": "Unknown",
        "value": "Listed",
        "color_code": "#8EE392"
    },
}